<ng-container *ngIf="!showError">
  <h1 class="title">Email verification required</h1>
  <p class="description">Press "Continue" to proceed to verify your email address.</p>
  <div class="button-container">
    <button class="button button-pill button-reverse" [disabled]="callInProgress" (click)="confirmEmail()">
      Continue
    </button>
  </div>
</ng-container>
<ng-container *ngIf="showError">
  <svg-icon src="/assets/icons/alert-circle.svg" class="alert-icon"></svg-icon>
  <div class="title">Something went wrong</div>
  <p class="description">Your email verification code request was not processed. Please try again.</p>
  <p class="description">If the problem persists, contact us at support@kumanu.com.</p>
  <div class="button-container">
    <button class="button button-pill button-reverse full-width" (click)="dismissModal()">Close</button>
  </div>
</ng-container>
